// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import translate from "@insite/client-framework/Translate";
import DynamicDropdown, {
    DynamicDropdownPresentationProps,
    OptionObject,
} from "@store/MobiusOverrides/DynamicDropdown/DynamicDropdown";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import updateDraftParameter from "@store/Framework/Store/Greif/Pages/OrderHistory/Handlers/UpdateDraftParameter";
import { useOrderHistoryState } from "@store/Framework/Store/Greif/Pages/OrderHistory/OrderHistoryHooks";
import FilterDrawerSection from "@store/Library/Components/FilterDrawerSection";
import { filterDrawerProps } from "@store/Themes/common/props/filterDrawer";
import React, { FC, useCallback, useEffect, useMemo, useState } from "react";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import debounce from "lodash/debounce";
import constants from "@store/constants";
import { useFilterDrawerContext } from "@store/Library/Components/FilterDrawerAndButton";

export interface OrderHistoryFilterFieldPlantProps {}

export interface OrderHistoryFilterFieldPlantStyles {
    dynamicDropdown?: DynamicDropdownPresentationProps;
}

export const OrderHistoryFilterFieldPlantStyles: OrderHistoryFilterFieldPlantStyles = {
    dynamicDropdown: filterDrawerProps.dynamicDropdown,
};

const styles = OrderHistoryFilterFieldPlantStyles;

const OrderHistoryFilterFieldPlant: FC<OrderHistoryFilterFieldPlantProps> = () => {
    const [options, setOptions] = useState<OptionObject[]>([]);
    const { scrollElement } = useFilterDrawerContext();
    const dispatch = useAppDispatch();
    const locations = useAppSelector(state => state.greif.components.locationFilters.locations);
    const { location } = useOrderHistoryState().draftParameter;
    const [search, setSearch] = useState("");
    const [filter, setFilter] = useState(search);
    const debouncedSetFilter = useCallback(debounce(setFilter, constants.searchDebounceDelay), []);
    const id = useMemo(uniqueId, []);

    useEffect(() => {
        let nextOptions: OptionObject[] = [];
        const lowerCaseFilter = filter.trim().toLowerCase();
        const hasFilter = Boolean(lowerCaseFilter);

        if (locations && locations.length) {
            let filteredPlants = locations;

            if (hasFilter) {
                filteredPlants = locations.filter(x => x.locationDescription.toLowerCase().includes(lowerCaseFilter));
            }

            nextOptions = filteredPlants.map(({ location, locationDescription }) => ({
                optionText: locationDescription,
                optionValue: location,
            }));
        }

        if (!hasFilter) {
            nextOptions.unshift({
                optionText: translate("Show All Greif Locations"),
                optionValue: constants.locations.showAll,
            });
        }

        setOptions(nextOptions);
    }, [locations, filter]);

    return (
        <FilterDrawerSection title={translate("Greif Location")} labelFor={id}>
            <DynamicDropdown
                {...styles.dynamicDropdown}
                data-test-selector="orderHistory_filterLocation"
                filterOption={() => true}
                options={options}
                onSelectionChange={data =>
                    dispatch(updateDraftParameter({ location: data === constants.locations.showAll ? "" : data }))
                }
                onInputChange={event => {
                    setSearch(event.currentTarget.value);
                    debouncedSetFilter(event.currentTarget.value);
                }}
                placeholder={translate("Select Location")}
                selected={location || constants.locations.showAll}
                uid={id}
                scrollElement={scrollElement}
            />
        </FilterDrawerSection>
    );
};

export default OrderHistoryFilterFieldPlant;
